import { useTranslation } from 'react-i18next'

import styles from './AssignmentsHeader.module.scss'

const AssignmentsHeader = ({ tab, setTab, isStudent, isTeacher }) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.header}`}>
      <h1 className={styles.title}>{t('assignments.title')}</h1>
      <div className={styles.tabs}>
        {isStudent && (
          <>
            <button
              className={`unv-btn ${tab === 'available' ? '' : 'unv-btn--ghost'}`}
              onClick={() => setTab('available')}
            >
              {t('assignments.tab_available')}
            </button>
            <button
              className={`unv-btn ${tab === 'mine' ? '' : 'unv-btn--ghost'}`}
              onClick={() => setTab('mine')}
            >
              {t('assignments.tab_my_subs')}
            </button>
          </>
        )}
        {isTeacher && (
          <>
            <button
              className={`unv-btn ${tab === 'my-tasks' ? '' : 'unv-btn--ghost'}`}
              onClick={() => setTab('my-tasks')}
            >
              {t('assignments.tab_my_tasks')}
            </button>
            <button
              className={`unv-btn ${tab === 'review' ? '' : 'unv-btn--ghost'}`}
              onClick={() => setTab('review')}
            >
              {t('assignments.tab_review')}
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default AssignmentsHeader
